<template>
  <div>
    <div>
      <vxe-grid
        ref="expenseTable"
        show-overflow
        highlight-hover-row
        :data.sync="tableData"
        :columns="tableColumns"
        :toolbar-config="tableToolbar"
        :edit-rules="validRules"
        row-key
        size="small"
        auto-resize
        resizable
        border
        :edit-config="{ trigger: 'click', mode: 'row' }"
        @edit-closed="editClosedEvent"
      >
        <template v-slot:toolbar_form>
          <slot name="header">
            <div class="side-frame-warning">
              <span class="side-frame-text">费用明细</span>
              <el-divider direction="vertical"></el-divider>
              <el-button
                type="primary"
                icon="el-icon-plus"
                size="small"
                @click="add()"
                >{{ $l('INDEX.product_dialog_btn_add') || '添加' }}</el-button
              >
              <el-button
                type="danger"
                icon="el-icon-delete"
                size="small"
                @click="removeCheckbox()"
                >{{ $l('INDEX.btn_tips_del') || '删除' }}</el-button
              >
            </div>
          </slot>
        </template>
      </vxe-grid>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    data: {
      type: Array,
      default: () => [],
    },
    orderFee: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      tableData: [],
      orderFees: 0,
      formData: { identifyNo: '' },
      validRules: {
        basePrice: [
          { required: true, message: '费用必须填写' },
          {
            pattern: /^[0-9]+(\.[0-9]{1,3})?$/,
            message: '请输入正确的费用信息',
            trigger: 'blur',
          },
        ],
        feeName: [{ required: true, message: '费用类型必须填写' }],
      },
      tableToolbar: {
        slots: {
          buttons: 'toolbar_form',
        },
      },
      tableColumns: [
        {
          field: 'seq',
          width: 40,
          align: 'center',
          fixed: 'left',
          type: 'seq',
        },
        {
          width: 50,
          align: 'center',
          fixed: 'left',
          type: 'checkbox',
        },
        {
          field: 'feeName',
          headerAlign: 'center',
          align: 'center',
          minWidth: 150,
          title: '费用类型',
          editRender: {
            name: 'dict-select',
            props: {
              default: true,
              clearable: true,
              filterable: true,
              placeholder: '请选择费用类型',
              body: { type: 'feeName' },
            },
          },
        },
        {
          field: 'basePrice',
          headerAlign: 'center',
          align: 'center',
          minWidth: 100,
          title: '费用',
          editRender: {
            name: 'ElInputNumber',
            props: {
              controlsPosition: 'right',
              style: 'width:100%',
              min: 0,
              step: 0.01,
              precision: 2,
            },
            placeholder: '请输入费用',
            immediate: true,
          },
        },
      ],
    }
  },
  watch: {
    data: {
      handler(val) {
        if (val) this.tableData = val
      },
      immediate: true,
    },
  },

  methods: {
    async add(row) {
      const $table = this.$refs.expenseTable
      const { row: newRow } = await $table.insertAt({}, row, newRow)
    },
    getTableData() {
      const { tableData } = this.$refs.expenseTable.getTableData()
      return tableData.map((row) => {
        return {
          basePrice: row.basePrice,
          feeNameText: row.feeNameText,
          feeName: row.feeName,
        }
      })
    },

    editClosedEvent() {
      this.tableData = this.$refs.expenseTable.getTableData().fullData
      this.orderFees = 0
      this.tableData.forEach((items) => {
        this.orderFees += items.basePrice
      })
      this.$emit('update:payFeeAmount', this.orderFees)
    },

    async validEvent() {
      return await this.$refs.expenseTable
        .fullValidate(true)
        .then(() => {
          return true
        })
        .catch(() => false)
    },

    removeCheckbox() {
      this.$refs.expenseTable.removeCheckboxRow()
      this.editClosedEvent()
    },
  },
}
</script>
